import { render, staticRenderFns } from "./StreamingMediaPlayer.vue?vue&type=template&id=2bece656&scoped=true"
import script from "./StreamingMediaPlayer.vue?vue&type=script&lang=js"
export * from "./StreamingMediaPlayer.vue?vue&type=script&lang=js"
import style0 from "./StreamingMediaPlayer.vue?vue&type=style&index=0&id=2bece656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bece656",
  null
  
)

export default component.exports